import { createFileRoute } from "@tanstack/react-router";
import OrgQuality from "../../../../../views/content/OrgQuality";

export const Route = createFileRoute("/_authenticated/user/content/quality/org")({
  component: OrgQuality,
  staticData: { application: "Product" },
});
